module.exports = __webpack_public_path__ + "static/teag2-f681e1debebc4d79d576cbdc0b35c6a3.jpg";